import { useCallback, useEffect, useRef, useState } from 'react';
import { SxProps, Tooltip, TooltipProps, tooltipClasses } from '@mui/material';
import styled from 'styled-components';
import { Theme } from '@mui/material/styles';
import { Variant } from '@mui/material/styles/createTypography';
import { colorTheme } from '@styles/muiTheme';
import { TooltipTyporaphy } from '@styles/CommonStyles';

export const LightTooltip = styled(({ className, ...props }: TooltipProps) => <Tooltip {...props} classes={{ popper: className }} />)(() => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: colorTheme.palette.common.black,
    fontSize: 14,
  },
}));

interface ITooltipTextProps {
  text?: string;
  line?: number;
  sx?: SxProps<Theme>;
  variant?: Variant;
  isBold?: boolean;
  isWordBreak?: boolean;
}

export const GridCell = ({ text = '', sx = {}, line = 1, variant = 'body1', isWordBreak = false, isBold = false }: ITooltipTextProps) => {
  const [hoverStatus, setHover] = useState(false);
  const textElementRef = useRef<HTMLDivElement>(null);

  const compareSize = useCallback(() => {
    if (textElementRef.current) {
      const scrollHeight = textElementRef.current.scrollHeight;
      const clientHeight = textElementRef.current.clientHeight;
      const scrollWidth = textElementRef.current.scrollWidth;
      const clientWidth = textElementRef.current.clientWidth;
      setHover(scrollHeight > clientHeight || scrollWidth > clientWidth);
    }
  }, [textElementRef]);

  useEffect(() => {
    compareSize();
    window.addEventListener('resize', compareSize);

    return () => {
      window.removeEventListener('resize', compareSize);
    };
  }, []);

  return (
    <LightTooltip title={text} disableHoverListener={!hoverStatus} placement="top">
      <TooltipTyporaphy ref={textElementRef} $isBold={isBold} $isWordBreak={isWordBreak} line={line} variant={variant} sx={{ ...sx }}>
        {text}
      </TooltipTyporaphy>
    </LightTooltip>
  );
};
